import $ from 'jquery';

$(function() {

    /**
     * GA4 Trigger - Form Submitted & Swatch Ordered
     * Events: form_submitted, swatch_ordered
     */
    document.addEventListener('wpcf7mailsent', function({ detail }) {
        let eventName = '';
        if (detail.contactFormId === 123) {
            eventName = 'form_submitted';
        } else if (detail.contactFormId === 808) {
            eventName = 'swatch_ordered';
        }
        window.dataLayer.push({event: eventName});
    }, false);

    /**
     * GA4 Trigger - Product PDF Download
     * Event: product_pdf_download
     */
    $('.product-downloads__item a').on('click', function(e) {
        window.dataLayer.push({
            event: 'product_pdf_download',
            product: $('.product-info__title').text(),
            file: $(this).attr('href'),
        });
    });

    /**
     * GA4 Trigger - Facebook Click
     * Event: facebook_click
     */
    $('.social-facebook').on('click', function(e) {
        window.dataLayer.push({event: 'facebook_click'});
    });

    /**
     * GA4 Trigger - Twitter Click
     * Event: twitter_click
     */
    $('.social-twitter').on('click', function(e) {
        window.dataLayer.push({event: 'twitter_click'});
    });

    /**
     * GA4 Trigger - Instagram Click
     * Event: instagram_click
     */
    $('.social-instagram').on('click', function(e) {
        window.dataLayer.push({event: 'instagram_click'});
    });

    /**
     * GA4 Trigger - Youtube Click
     * Event: youtube_click
     */
    $('.social-youtube').on('click', function(e) {
        window.dataLayer.push({event: 'youtube_click'});
    });

    /**
     * GA4 Helper - User Registered
     */
    if ($('.js-register-form input[name="_wp_http_referer"]') && window.location.href.includes('dashboard')) {
        $('.js-register-form input[name="_wp_http_referer"]').val('/dashboard/?gtm-event=user_registered')
    }


});

/**
 * GA4 Trigger - Add to Cart
 * Event: add_to_cart
 *
 * @param total
 * @param itemData
 */
export function trackAddToCart(total, itemData) {
    window.dataLayer.push({
        event: 'add_to_cart',
        ecommerce: {
            currency: 'GBP',
            value: total,
            items: [{
                ...itemData
            }],
        }
    });
};
